import { cva } from "../../lib";
import type { SkeletonRadius, SkeletonVariant } from "./types";

// A Skeleton takes `variant` or `radius`, never both, so it passes one of them
export const skeletonVariants = cva("bg-luce-neutral-background-attenuated", {
  variants: {
    /** Border-radius only. `rounded` is the text-line radius */
    variant: {
      rounded: "rounded-radius-sm",
      circular: "rounded-radius-full",
      rectangular: "rounded-radius-none",
    } satisfies Record<SkeletonVariant, string>,
    radius: {
      none: "rounded-radius-none",
      sm: "rounded-radius-sm",
      md: "rounded-radius-md",
      lg: "rounded-radius-lg",
      xl: "rounded-radius-xl",
      "2xl": "rounded-radius-2xl",
      full: "rounded-radius-full",
    } satisfies Record<SkeletonRadius, string>,
    // Static when reduced motion is requested (split row 205). Native's
    // Reanimated-driven pulse already stops by its own default
    animate: {
      true: "animate-pulse motion-reduce:animate-none",
      false: "",
    },
  },
});
